import React from 'react'
import { Alert, Button, Icon } from 'antd'

const VoiceLibrarySection = ({
  title,
  description,
  onRefresh,
  isRefreshing,
  error,
  isLoading,
  loadingText,
  emptyIcon,
  emptyText,
  children
}) => (
  <div className="voice-selection-modal__library-section">
    <div className="voice-selection-modal__header">
      <div className="voice-selection-modal__section-copy">
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
      <Button
        type="default"
        icon="reload"
        onClick={onRefresh}
        loading={isRefreshing}
        className="voice-selection-modal__refresh-btn"
      >
        Refresh
      </Button>
    </div>

    {error && (
      <Alert
        message={error}
        type="warning"
        showIcon
        className="voice-selection-modal__alert"
      />
    )}

    {isLoading ? (
      <div className="voice-selection-modal__state-card">
        <div className="processing-visual">
          <div className="custom-loader" />
          <div className="loader-center">
            <div className="inner-dot" />
          </div>
        </div>
        <p>{loadingText}</p>
      </div>
    ) : children ? (
      children
    ) : (
      <div className="voice-selection-modal__state-card voice-selection-modal__state-card--empty">
        <Icon type={emptyIcon} />
        <p>{emptyText}</p>
      </div>
    )}
  </div>
)

export default VoiceLibrarySection
